import { CHECKOUT_ACTIONS } from './checkout.types'

export const setCheckoutStatusAction = payload => ({
  type: CHECKOUT_ACTIONS.SET_STATUS,
  payload
})

export const setCheckoutErrorsAction = payload => ({
  type: CHECKOUT_ACTIONS.SET_ERRORS,
  payload
})

export const clearCheckoutErrorsAction = () => ({
  type: CHECKOUT_ACTIONS.CLEAR_ERRORS
})

export const setValidationStatusAction = payload => ({
  type: CHECKOUT_ACTIONS.SET_VALIDATION_STATUS,
  payload
})

export const setValidationErrorsAction = payload => ({
  type: CHECKOUT_ACTIONS.SET_VALIDATION_ERRORS,
  payload
})

export const clearValidationErrorsAction = () => ({
  type: CHECKOUT_ACTIONS.CLEAR_VALIDATION_ERRORS
})
